import "./RegisterBox.css"

function HeroMessage() {
    return (
        <div className = "hero-wrapper">
            <div className = "HeroMessage">
                <div style={{color:"#053c5e"}}>Connect, Study, Explore</div>{/*Hero Message<br/>*/}
                Engage with students <br/>in the UB Community
            </div>
            <div className = "SecondaryMessage">
                Participate in activities happening near you.<br/>
                See what your classmates are up to.<br/>
                Organize Events with other students.<br/>
                {/* Secondary Message. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. */}
            </div>
        </div>
    )
}
export default HeroMessage